module.exports = __webpack_public_path__ + "static/media/pasamosagosto3.79483cab.webp";